import { render, staticRenderFns } from "./JTreeTable.vue?vue&type=template&id=7304ff33&scoped=true&"
import script from "./JTreeTable.vue?vue&type=script&lang=js&"
export * from "./JTreeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7304ff33",
  null
  
)

export default component.exports